import styled from 'styled-components'
import Description from '../../components/Description/Description'
import Title from '../../components/Title/Title'
import chrome from '../../images/icons/chrome-icon.svg'
import firefox from '../../images/icons/firefox-icon.svg'
import edge from '../../images/icons/edge-icon.svg'

const Container = styled.div`
  display: flex;
  justify-content: center;
  padding: 50px 0;
`
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
`
const Grid1 = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 50px;
  justify-items: center;
`
const Grid3 = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 50px;
  width: fit-content;
`
const Icon = styled.img`
  width: 75px;
  height: 75px;
`

export default function Browsers() {
  return (
    <Container>
      <div className="container">
        <Wrapper>
          <Grid1>
            <Title title="Works on your browser" />
            <Description description="Google Chrome, Mozilla Firefox, and Microsoft Edge. The top 3 browsers are supported by GDark." />
            <Grid3 className="browsers__grid3">
              <Icon src={chrome} alt="Google Chrome" />
              <Icon src={firefox} alt="Mozilla Firefox" />
              <Icon src={edge} alt="Microsoft Edge" />
            </Grid3>
          </Grid1>
        </Wrapper>
      </div>
    </Container>
  )
}
